import { uniq } from 'lodash';

export const EXTENSIONS_FETCH = 'EXTENSIONS/FETCH';
export const EXTENSIONS_FETCH_SUCCESS = 'EXTENSIONS/FETCH_SUCCESS';
export const EXTENSIONS_FETCH_FAILURE = 'EXTENSIONS/FETCH_FAILURE';
export const EXTENSIONS_DELETE_EXTENSION = 'ACTORS/DELETE_ACTOR';
export const EXTENSIONS_DELETE_EXTENSION_SUCCESS =
  'ACTORS/DELETE_ACTOR_SUCCESS';
export const EXTENSIONS_DELETE_EXTENSION_FAILURE =
  'ACTORS/DELETE_ACTOR_FAILURE';
export const EXTENSIONS_SEARCH = 'LOCATIONS/SEARCH';
export const EXTENSIONS_SEARCH_SUCCESS = 'LOCATIONS/SEARCH_SUCCESS';
export const EXTENSIONS_SEARCH_FAILURE = 'LOCATIONS/SEARCH_FAILURE';

export const EXTENSIONS_NAME_SEARCH = 'EXTENSIONS/NAME_SEARCH';
export const EXTENSIONS_NAME_SEARCH_SUCCESS = 'EXTENSIONS/NAME_SEARCH_SUCCESS';
export const EXTENSIONS_NAME_SEARCH_FAILURE = 'EXTENSIONS/NAME_SEARCH_FAILURE';

export const EXTENSIONS_FETCH_TAGS = 'TAGS/FETCH';
export const EXTENSIONS_FETCH_TAGS_SUCCESS = 'TAGS/FETCH_SUCCESS';
export const EXTENSIONS_FETCH_TAGS_FAILURE = 'TAGS/FETCH_FAILURE';
export const EXTENSIONS_TOGGLE_TAG = 'TAG/EXTENSIONS_TOGGLE_TAG';
export const EXTENSIONS_FETCH_TYPE = 'EXTENSIONS/FETCH/TYPE';
export const CLEAR_CURRENT_TAGS = 'CLEAR/CURRENT/TAGS';
export const CLEAR_TAGS_LIST = 'CLEAR/TAGS/LIST';

//internal action from saga only
export const EXTENSIONS_TOGGLE_TAGS = 'EXTENSIONS_TOGGLE_TAGS';

export const EXTENSIONS_MOVE_FILE = 'EXTENSION/MOVE_FILE';
export const EXTENSIONS_MOVE_FILE_SUCCESS = 'EXTENSION/MOVE_FILE_SUCCESS';

const initialState = {
  list: [],
  queryList: [],
  tagsList: [],
  currentTags: [],
  showMore: false,
  type: '',
};

export const fetchExtensions = () => ({
  type: EXTENSIONS_FETCH,
});

export const deleteExtension = id => ({
  type: EXTENSIONS_DELETE_EXTENSION,
  payload: { id },
});

export const fetchExtensionsByQuery = (type, name, tags) => ({
  type: EXTENSIONS_SEARCH,
  payload: { type, name, tags },
});

export const fetchExtensionsByName = (query, type) => ({
  type: EXTENSIONS_NAME_SEARCH,
  payload: { query, type },
});

export const fetchExtensionsTags = (query, type) => ({
  type: EXTENSIONS_FETCH_TAGS,
  payload: { query, type },
});

export const toggleExtensionsTag = (query, tag, type) => ({
  type: EXTENSIONS_TOGGLE_TAG,
  payload: {
    query,
    tag,
    type,
  },
});

export const fetchExtensionsType = type => ({
  type: EXTENSIONS_FETCH_TYPE,
  payload: { type },
});

export const clearCurrentTags = () => ({
  type: CLEAR_CURRENT_TAGS,
});

export const extensionMoveFile = (folderId, fileId) => ({
  type: EXTENSIONS_MOVE_FILE,
  payload: { folderId, fileId },
});

export const extensionMoveFileSuccess = fileId => ({
  type: EXTENSIONS_MOVE_FILE_SUCCESS,
  payload: { fileId },
});

export const clearTagsList = () => ({
  type: CLEAR_TAGS_LIST,
});

export const extensionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EXTENSIONS_FETCH: {
      return {
        ...state,
        list: [],
      };
    }
    case EXTENSIONS_FETCH_SUCCESS: {
      return {
        ...state,
        list: [...payload],
      };
    }
    case EXTENSIONS_DELETE_EXTENSION_SUCCESS: {
      return {
        ...state,
        list: state.list.filter(extension => extension.id !== payload.id),
      };
    }
    case EXTENSIONS_SEARCH_SUCCESS: {
      return {
        ...state,
        list: [...payload],
      };
    }
    case EXTENSIONS_NAME_SEARCH_SUCCESS: {
      return {
        ...state,
        queryList: [...payload],
      };
    }
    case EXTENSIONS_FETCH_TAGS_SUCCESS: {
      const tags = uniq(payload.tags);
      return {
        ...state,
        tagsList: tags,
      };
    }
    case EXTENSIONS_TOGGLE_TAGS: {
      let newTags = [];
      if (payload.tag === null) {
        //clear list
      } else if (state.currentTags.indexOf(payload.tag) !== -1) {
        newTags = state.currentTags.filter(tag => tag !== payload.tag);
      } else {
        newTags = [...state.currentTags, payload.tag];
      }
      return { ...state, currentTags: [...newTags] };
    }
    case EXTENSIONS_FETCH_TYPE: {
      return {
        ...state,
        type: payload.type,
      };
    }
    case CLEAR_CURRENT_TAGS: {
      return {
        ...state,
        currentTags: [],
      };
    }
    case EXTENSIONS_MOVE_FILE_SUCCESS: {
      return {
        ...state,
        list: state.list.filter(
          extensionFile => extensionFile.id !== payload.fileId
        ),
      };
    }
    case CLEAR_TAGS_LIST: {
      return {
        ...state,
        tagsList: [],
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/extensions.reducer.js